import parseHtml, { domToReact } from "html-react-parser";
import type { DOMNode, HTMLReactParserOptions } from "html-react-parser";
import { createElement, Fragment, type ReactNode } from "react";

/*
 * Article and journal titles reach us carrying JATS inline formatting — from our
 * own XML and, on the citation pages, from Crossref, OpenAlex and OpenCitations.
 * Only these tags survive, and every attribute is dropped, so third-party title
 * strings can carry no href, style or event handler.
 */
const ALLOWED_TAGS = new Set([
  "b",
  "em",
  "i",
  "s",
  "small",
  "strong",
  "sub",
  "sup",
  "u",
]);

const DISCARDED_TAGS = new Set(["script", "style"]);

const options: HTMLReactParserOptions = {
  replace: (node) => {
    const element = node as { name?: string; children?: DOMNode[] };

    if (element.name === undefined) {
      return undefined;
    }

    if (DISCARDED_TAGS.has(element.name)) {
      return createElement(Fragment, null);
    }

    const children = domToReact(element.children ?? [], options);

    return ALLOWED_TAGS.has(element.name)
      ? createElement(element.name, null, children)
      : createElement(Fragment, null, children);
  },
};

export const renderInlineMarkup = (value?: string | null): ReactNode =>
  value ? parseHtml(value, options) : null;
